import React from 'react'
import { Badge, MenuItem, Select } from "@material-ui/core"

const SelectField = ({ mapData, value, handleChangeValue, disabled, iconMap, colorMap, badgeMap }) => {
    const renderValue = (val) => {
        const Icon = iconMap && iconMap[val];
        const badge = badgeMap && badgeMap[val];
        return (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                {Icon && (
                    badge
                        ? <Badge badgeContent={badge} style={{ fontSize: 11 }}><Icon style={{ fontSize: 16 }} /></Badge>
                        : <Icon style={{ fontSize: 16 }} />
                )}
                {mapData[val]}
            </span>
        );
    };

    return (
        <Select style={{ width: '100%' }} value={value} onChange={ev => handleChangeValue(ev.target.value)} disabled={!!disabled} renderValue={renderValue}>
            {Object.keys(mapData).map(key => {
                const Icon = iconMap && iconMap[key];
                const color = colorMap && colorMap[key];
                return (
                    <MenuItem key={key} value={key}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                            {Icon && <Icon style={{ fontSize: 16, color: color || 'inherit' }} />}
                            {mapData[key]}
                        </span>
                    </MenuItem>
                );
            })}
        </Select>
    )
}

export default SelectField